import * as React from 'react';

class TestHome extends React.Component {
    constructor(props) {
        super(props);
        this.componentName= "[TestHome.jsx] ";
    }

    render() {
        console.log(this.componentName + 'render');
        return (
            <div>
                <h1>Test</h1>
               
            </div>
        );
    }
}


export default TestHome;